import apiClient from "../../../apiClient/apiClient";
import { GET_WISHLIST_REQUEST, GET_WISHLIST_SUCCESS, GET_WISHLIST_FAILURE, GET_WISHLIST_AFTER_DELETE } from "../constant/fetchWishlistConstant";

// Add this to prevent repeated requests
let isLoadingWishlist = false;

export const getWishlist = () => async(dispatch, getState) => {
    // Prevent multiple simultaneous requests
    if (isLoadingWishlist) {
        console.log("Wishlist fetch already in progress, skipping");
        return;
    }

    // Check if we already have wishlist data to avoid unnecessary fetches
    const currentWishlist = getState().wishlist?.wishlist;
    if (currentWishlist && currentWishlist.length > 0) {
        console.log("Wishlist already loaded, using cached data");
        return;
    }

    try {
        isLoadingWishlist = true;
        dispatch({
            type: GET_WISHLIST_REQUEST
        });

        const token = localStorage.getItem("access") || sessionStorage.getItem("access");
        
        if (!token) {
            throw new Error("No authentication token available");
        }

        console.log("Fetching wishlist from API");
        const response = await apiClient.get('/wishlist/list/');
        
        dispatch({
            type: GET_WISHLIST_SUCCESS,
            payload: response.data
        });
        
        console.log("Wishlist fetch successful:", response.data);
    } catch (error) {
        console.error("Error fetching wishlist:", error);
        dispatch({
            type: GET_WISHLIST_FAILURE,
            payload: {
                message: error.message || 'Error fetching Wishlist'
            }
        });
    } finally {
        isLoadingWishlist = false;
    }
};

export const getWishlistAfterDelete = (eventId) => (dispatch) => {
    dispatch({
        type: GET_WISHLIST_AFTER_DELETE,
        payload: eventId
    });
};